/**
 * Missing Price Exception Config
 *
 * Covers: ex-inv-ls-missing-price
 *
 * Active inventory products with null/zero supply price or retail price.
 * Column layout and error chips live in the shared product-exception
 * module — this file only names the code and its primary error chip.
 */
import { buildProductExceptionConfig } from '../shared/productExceptionColumns'

export const missingPriceConfig = buildProductExceptionConfig({
  codes: ['ex-inv-ls-missing-price'],
  // Primary chip is picked per-row on the backend — retail_price_missing
  // when that's the cause, otherwise supplier_price_missing.
})
